import { render, staticRenderFns } from "./IntegrationSettingsDrawerHeader.vue?vue&type=template&id=22a14c3e&scoped=true&"
import script from "./IntegrationSettingsDrawerHeader.vue?vue&type=script&lang=js&"
export * from "./IntegrationSettingsDrawerHeader.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationSettingsDrawerHeader.vue?vue&type=style&index=0&id=22a14c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a14c3e",
  null
  
)

export default component.exports